import type { ComponentType } from 'react';

import type { LoadableType } from '@confluence/loadable';
import { LoadableLazy } from '@confluence/loadable';

export const SpacesDropdown: LoadableType<{
	closePopup?: (reason?: string | undefined) => void;
	updatedEmptyState?: ComponentType;
}> = LoadableLazy({
	loader: async () =>
		(
			await import(
				/* webpackChunkName: "loadable-global-spaces-dropdown" */ '../src/SpacesDropdown.tsx'
			)
		).SpacesDropdown,
});
export { SpacesDropdownLoader } from './SpacesDropdownLoader.ts';
